import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { SkillsContentResponse } from './schemas'
import { SkillSource } from '@/analytics/schema/events.schema'

export type SkillsState = {
  skillsContentData: SkillsContentResponse
  skillsContentLoading: boolean
  skillsContentError: boolean
  skillInitLoading: string | null // The skill enum that is loading
  skillInitError: string | null // The skill enum that has an error
  activeSkillForConversation: Record<string, { skill: string; skillSource: SkillSource } | null>
}

const initialState: SkillsState = {
  skillsContentData: {
    skills: [],
  },
  skillsContentLoading: false,
  skillsContentError: false,
  skillInitLoading: null,
  skillInitError: null,
  activeSkillForConversation: {},
}

/**
 * Skills Slice
 * Holds artifact versions to be displayed to the user.
 */
export const skillsSlice = createSlice({
  name: 'skillsState',
  initialState,
  reducers: {
    // ============== Listener Actions ============== >
    fetchSkillsContent: (_state) => {
      // Handled by the listener middleware
    },

    initializeConversationWithSkill: (_state, _action: PayloadAction<{ conversationId: string; skill: string; skillSource?: SkillSource }>) => {
      // Handled by the listener middleware
    },

    // ============== Slice Actions ============== >
    nullifyData: () => initialState,

    // Set loading state
    setSkillsContentLoading: (state, action: PayloadAction<boolean>) => {
      state.skillsContentLoading = action.payload
    },

    // Set error state
    setSkillsContentError: (state, action: PayloadAction<boolean>) => {
      state.skillsContentError = action.payload
    },

    // Set skills content data
    setSkillsContentData: (state, action: PayloadAction<SkillsContentResponse>) => {
      state.skillsContentData = action.payload
    },

    // Set skill initialization loading state
    setSkillInitLoading: (state, action: PayloadAction<{ skill: string | null }>) => {
      state.skillInitLoading = action.payload.skill
    },

    // Set skill initialization error state
    setSkillInitError: (state, action: PayloadAction<{ skill: string | null }>) => {
      state.skillInitError = action.payload.skill
    },

    // Set pending skill for a conversation
    setPendingSkillForConversation: (state, action: PayloadAction<{ conversationId: string; skill: string; skillSource: SkillSource }>) => {
      state.activeSkillForConversation[action.payload.conversationId] = { skill: action.payload.skill, skillSource: action.payload.skillSource }
    },
  },
})

// Actions
export const SkillsActions = skillsSlice.actions

export default skillsSlice.reducer
